import { render } from "./PublicPolitique.vue?vue&type=template&id=58ced7a0"
import script from "./PublicPolitique.vue?vue&type=script&lang=js"
export * from "./PublicPolitique.vue?vue&type=script&lang=js"

import "./PublicPolitique.vue?vue&type=style&index=0&id=58ced7a0&lang=css"

import exportComponent from "C:\\MesProjets\\Labs\\akdevmatik\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__